import { ApiQueryKey } from '@/configs/ApiQueryKey';
import { AppUser } from '@/types/users';
import httpClient from './httpClient';

interface UpdatePasswordPayload {
	oldPassword: string;
	password: string;
}

class UserApi {
	queryKey = ApiQueryKey.me;

	constructor() {}

	async getCurrentUser() {
		const response = await httpClient.get<AppUser>(this.queryKey);
		return response.data;
	}

	async update(payload: UpdatePasswordPayload) {
		const response = await httpClient.patch(`auth/me`, payload);
		return response.data;
	}
}

export default new UserApi();
